import React from "react"
import {Link, useLocation} from "react-router-dom"
import BootstrapBreadcrumb from "react-bootstrap/Breadcrumb"

import {URL_BACKOFFICE} from "static/constant/url"
import "./style.scss"

const segmentLabels: {[key: string]: string} = {
  transcode: "Transcodage",
  import: "Imports",
  job: "Jobs",
  storage: "Stockage",
  provider: "Providers",
  inbox: "Inbox média",
  media: "Médias",
  show: "Séries",
  movie: "Films",
  collection: "Collections",
  episode: "Épisodes",
  user: "Utilisateurs",
  add: "Ajouter",
  edit: "Modifier",
  list: "Liste",
  scan: "Scanner",
  status: "Statut",
}

export const BreadCrumb = () => {
  const {pathname} = useLocation()
  const segments = pathname.split("/").filter(Boolean).slice(1)

  if (!pathname.startsWith(URL_BACKOFFICE) || !segments.length) return <div />

  return <BootstrapBreadcrumb className="breadcrumb-backoffice" aria-label="Fil d'Ariane">
    <BootstrapBreadcrumb.Item><Link to={URL_BACKOFFICE}>Backoffice</Link></BootstrapBreadcrumb.Item>
    {segments.map((segment, index) => {
      const isIdentifier = segment.length > 20 || /^\d+$/.test(segment)
      const label = segmentLabels[segment] || (isIdentifier ? "Détail" : segment)
      return <BootstrapBreadcrumb.Item active key={`${segment}-${index}`}>{label}</BootstrapBreadcrumb.Item>
    })}
  </BootstrapBreadcrumb>
}
